
export const MinimumHeight = 800
export const BottomCirclesHeight = 52
export const ContentSectionHeight = 43
export const NavBarHeight = 80
